// extracted by mini-css-extract-plugin
export default {"dividerWrapper":"src-client-components-Divider-styles-___default__dividerWrapper___ESOfR","divider":"src-client-components-Divider-styles-___default__divider___tA17P"};